import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

interface ThemeStore {
  // Theme preference (persisted)
  theme: Theme;

  // Resolved theme (actual theme being applied: 'light' or 'dark')
  resolvedTheme: 'light' | 'dark';

  // Actions
  setTheme: (theme: Theme) => void;
  setResolvedTheme: (resolvedTheme: 'light' | 'dark') => void;
  toggleTheme: () => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: 'light',
      resolvedTheme: 'light',

      setTheme: (theme: Theme) => set({ theme }),

      setResolvedTheme: (resolvedTheme: 'light' | 'dark') =>
        set({ resolvedTheme }),

      toggleTheme: () => {
        const currentTheme = get().theme;
        const newTheme = currentTheme === 'light' ? 'dark' : 'light';
        set({ theme: newTheme });
      },
    }),
    {
      name: 'theme-storage', // localStorage key
      // Only persist theme preference, not resolvedTheme
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);
